module.exports = __webpack_public_path__ + "img/allMarkers_disable.a58ddaac.svg";